import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M10 12.265a2.023 2.023 0 0 1 2 0 1.97 1.97 0 0 1 1 1.709v.402a2.734 2.734 0 0 1-.857 1.915l.57.112c1.355.316 2.287.993 2.287 1.78v2.253a.568.568 0 0 1-.571.564H7.57a.568.568 0 0 1-.57-.564v-2.253c0-.787.932-1.464 2.286-1.78.014-.003.378-.082.571-.112-.532-.5-.84-1.19-.857-1.915v-.402a1.97 1.97 0 0 1 1-1.71Z"></path><path d="M24 19a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6Z"></path><path d="M24 16a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6Z"></path><path d="M22 12a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4Z"></path><path fill-rule="evenodd" d="M26.204 8.01A2 2 0 0 1 28 10v12l-.01.204a2 2 0 0 1-1.786 1.785L26 24H6a2 2 0 0 1-1.99-1.796L4 22V10a2 2 0 0 1 2-2h20l.204.01ZM6 22h20V10H6v12Z" clip-rule="evenodd"></path></g>';
export var IdCardOutlineSVG = function IdCardOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
IdCardOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(IdCardOutlineSVG);